module.exports = __webpack_public_path__ + "media/images/royalslider/grab-749973ba090f02a3c9bbd4b2e797ae81.png";